import { Navigate, useSearchParams, Outlet } from 'react-router-dom';
import { useAuthStore, isValidToken } from '../../stores/authStore';

/**
 * Public route component
 * Redirects authenticated users away from public pages (e.g. login)
 * If already logged in with a valid token, redirects to home
 */
export default function PublicRoute() {
  const [searchParams] = useSearchParams();
  const { token, isAuthenticated } = useAuthStore();

  // Check whether the user is authenticated and has a valid token
  const isAuthValid = isAuthenticated && isValidToken(token);

  if (isAuthValid) {
    // 已登录时重定向到原始目标或首页
    const from = searchParams.get('redirect') || '/home';
    return <Navigate to={from} replace />;
  }

  // Not authenticated — render child routes (login page)
  return <Outlet />;
}
